import React from 'react';
import { TextInput, TextArea, CheckBox, Radio, DatePickerElement, Timepicker, DropDown } from './index';

export function ElementTemplate(props) {
  const mainFunction = () => {
    switch (props?.keys) {
      case 'Text':
        return <TextInput {...props} />;
      case 'Text_Area':
        return <TextArea {...props} />;
      case 'Check_Boxes':
        return <CheckBox {...props} />;
      case 'Dropdown':
        return <DropDown {...props} />;
      case 'Ratio_Button':
        return <Radio {...props} />;
      case 'Date_Picker':
        return <DatePickerElement {...props} />;
      case 'Time_Picker':
        return <Timepicker {...props} />;
      default:
        return <div className="height-150" />;
    }
  };
  return <>{mainFunction()}</>;
}

export default ElementTemplate;
